export interface MirrorSite {
  id: string;
  name: string;
  domain: string;
  status: "stable" | "new" | "backup" | "maintenance";
  statusText: string;
  description: string;
  region: string;
}

export const mirrorSites: MirrorSite[] = [
  { id: "m1", name: "主站入口", domain: "www.benzi-site.com", status: "stable", statusText: "正常", description: "官方网站主入口，线路稳定，推荐优先使用。", region: "全球 CDN" },
  { id: "m2", name: "备用新域名", domain: "new.benzi-home.net", status: "new", statusText: "新上线", description: "最新启用的永久备用域名，长期有效，可放心加入书签。", region: "全球 CDN" },
  { id: "m3", name: "镜像一号", domain: "mirror-01.benzi-top.net", status: "stable", statusText: "正常", description: "一号备用镜像，与主站数据实时同步，访问速度较快。", region: "香港节点" },
  { id: "m4", name: "镜像二号", domain: "mirror-02.benzi-backup.net", status: "backup", statusText: "备用", description: "二号备用镜像，主站繁忙时自动分流，保障流畅浏览。", region: "新加坡节点" },
  { id: "m5", name: "镜像三号", domain: "mirror-03.benzi-mirror.net", status: "backup", statusText: "备用", description: "三号备用镜像，长期稳定运行，建议一并收藏备用。", region: "日本节点" },
  { id: "m6", name: "镜像四号", domain: "mirror-04.benzi-site.net", status: "maintenance", statusText: "维护中", description: "四号镜像正在升级线路，恢复后会在本页第一时间通知。", region: "美国节点" },
];

export const statusFilter = [
  { key: "all", label: "全部入口" },
  { key: "stable", label: "正常" },
  { key: "new", label: "新域名" },
  { key: "backup", label: "备用" },
  { key: "maintenance", label: "维护中" },
];

export interface GuideStep {
  id: string;
  icon: string;
  title: string;
  desc: string;
}

export const guideSteps: GuideStep[] = [
  { id: "g1", icon: "ri-bookmark-line", title: "先收藏本页", desc: "按下 Ctrl+D 或点击收藏，把本站加入浏览器书签，方便随时回来找入口。" },
  { id: "g2", icon: "ri-signal-wifi-line", title: "原站打不开时来此", desc: "当本子网站原地址无法访问，直接打开这个导航页即可，无需到处寻找。" },
  { id: "g3", icon: "ri-shuffle-line", title: "任选一个镜像进入", desc: "根据入口状态，挑选标注“正常”或“新上线”的镜像继续浏览，内容与主站一致。" },
  { id: "g4", icon: "ri-message-3-line", title: "遇到问题就反馈", desc: "若所有入口都无法打开，通过页脚联系方式告知我们，会尽快更新可用地址。" },
];

export interface FaqItem {
  id: string;
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  { id: "f1", q: "什么是“镜像”？为什么需要备用地址？", a: "镜像是指与主站内容完全一致、部署在不同服务器上的副本站点。由于网络环境变化，主站地址可能不定期无法访问，因此我们准备了多个镜像，确保任何时候都能找到入口。" },
  { id: "f2", q: "镜像与主站内容一致吗？", a: "是的。所有镜像均与主站数据实时同步，栏目、内容与功能完全一致，您可以在任意入口获得相同的浏览体验。" },
  { id: "f3", q: "我应该优先使用哪个入口？", a: "建议优先选择状态标注为“正常”或“新上线”的入口，这些线路当前最稳定。若该入口繁忙，可切换到其他“备用”入口。" },
  { id: "f4", q: "收藏本站真的有用吗？", a: "非常有用。收藏本页相当于为原站留一条长期稳定的备用通道，原站无法访问时，打开书签即可直达最新可用入口，无需反复搜索。" },
  { id: "f5", q: "新域名上线后，旧域名还能用吗？", a: "新域名启用后，旧域名仍会保留一段时间并行运行。建议以本页标注的“新上线”入口为准，并顺手更新您的书签。" },
  { id: "f6", q: "本站收费吗？需要注册吗？", a: "本站为纯导航页面，完全免费，无需注册或登录，打开即可使用。" },
];

export interface Testimonial {
  id: string;
  name: string;
  role: string;
  text: string;
}

export const testimonials: Testimonial[] = [
  { id: "t1", name: "漫友小林", role: "收藏 2 年", text: "当初因为这本书栏收藏了导航页，原站几次打不开我都能靠镜像顺利继续追，太省心了。" },
  { id: "t2", name: "路过的读者", role: "普通用户", text: "界面清爽，入口状态一眼就能看清，换镜像也不用手忙脚乱，体验很好。" },
  { id: "t3", name: "潜水老读者", role: "深度用户", text: "唯一能稳定带我找回原站的导航，地址更新很及时，值得长期收藏。" },
];

export interface Announcement {
  id: string;
  title: string;
  date: string;
  content: string;
}

export const announcements: Announcement[] = [
  { id: "a1", title: "全新备用域名已上线", date: "2026-08-15", content: "为提升访问稳定性，本站正式启用全新备用域名 new.benzi-home.net，长期有效，欢迎加入书签。旧域名仍并行运行，过渡期内均可访问。" },
  { id: "a2", title: "主站线路已完成升级", date: "2026-08-02", content: "主站全球节点完成扩容，访问速度明显提升。所有镜像也已同步最新配置，整体稳定性进一步增强。" },
  { id: "a3", title: "二号镜像维护完成", date: "2026-07-20", content: "二号镜像已完成维护并恢复正常，可继续作为日常入口使用。感谢大家的耐心等待。" },
];